module.exports = __webpack_public_path__ + "static/media/clipboard.715e412d.svg";